<template>
  <div v-if="isLoading" class="home" style="padding-top: 100px;">
    <IconSeptima class="icon-septima"/>
    <span style="align-self: center;">Indlæser applikation. Vent venligst...</span>
  </div>
  <div v-else-if="!user" class="login">
    <IconSeptima class="icon-septima"/>
    <IconRetVejkodeActive
      width="48"
      height="51"
      icon-name="ret-vejkode"
    />
    <h1>Velkommen til RetVejkode</h1>
    <h2>Log ind med din GeoDK-bruger for at gå videre</h2>
    <Button :onClick="this.onLogin" :text="'Log ind'" />
  </div>
    <div v-else class="home">
      <div class="jumbotron-wrapper">
      <IconSeptima style="float: right; display:block; margin-right: -90px; margin-top: -70px;"/>
      <div class="jumbotron">
        <span id="icon-span">
          <svg width="78px" height="78px" viewBox="0 0 78 78" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="RetVejkode-Home" transform="translate(-298.000000, -184.000000)">
                      <g id="Group-17" transform="translate(298.000000, 185.000000)">
                          <g id="Vejkode-ikon">
                              <g id="Group-13" transform="translate(0.000000, 9.000000)" fill="#F5F6FA" fill-rule="nonzero">
                                  <path d="M64.6666667,22.1315789 L67.1666667,22.1315789 L67.1666667,63.626 C67.1666667,66.0416935 65.2083602,68 62.7926667,68 L4.374,68 C1.9583065,68 4.58697079e-15,66.0416935 0,63.626 L8.8817842e-16,4.66347368 C5.92341289e-16,2.24778019 1.9583065,0.289473684 4.374,0.289473684 L45.5,0.289473684 L45.5,2.78947368 L4.374,2.78947368 C3.33901838,2.78947368 2.5,3.62849206 2.5,4.66347368 L2.5,63.626 C2.5,64.6609816 3.33901838,65.5 4.374,65.5 L62.7926667,65.5 C63.8276483,65.5 64.6666667,64.6609816 64.6666667,63.626 L64.6666667,22.1315789 Z" id="Combined-Shape"></path>
                              </g>
                              <g id="Group-11" transform="translate(40.625000, 0.552632)" stroke="#F2F2F8" stroke-linejoin="round">
                                  <polygon id="Stroke-251" stroke-width="2.5" stroke-linecap="round" transform="translate(17.891232, 17.739581) rotate(-135.000000) translate(-17.891232, -17.739581) " points="23.3888757 37.3294934 12.5116827 37.2856337 12.393588 7.99813896 17.7923845 -1.85033121 23.2707809 8.04199861"></polygon>
                                  <polyline id="Stroke-252" stroke-width="2.187" transform="translate(11.370348, 24.302160) rotate(-135.000000) translate(-11.370348, -24.302160) " points="16.8089445 23.2473351 11.3791199 25.4008439 5.93175149 23.2034755"></polyline>
                                  <path d="M21.3659309,8.97990145 L32.2431239,9.0237611" id="Stroke-253" stroke-width="2.187" transform="translate(26.804527, 9.001831) rotate(-135.000000) translate(-26.804527, -9.001831) "></path>
                              </g>
                              <g id="Group-12" transform="translate(9.020833, 18.210526)">
                                  <g id="software_remove_vectorpoint" transform="translate(24.812500, 25.000000) scale(-1, 1) translate(-24.812500, -25.000000) translate(0.312500, 0.000000)" fill="#F6A31E" fill-rule="nonzero">
                                      <path d="M7.41666667,49.3684211 C3.59397717,49.3684211 0.5,46.2493914 0.5,42.4078947 C0.5,38.566398 3.59397717,35.4473684 7.41666667,35.4473684 C11.2393562,35.4473684 14.3333333,38.566398 14.3333333,42.4078947 C14.3333333,46.2493914 11.2393562,49.3684211 7.41666667,49.3684211 Z M7.41666667,46.3684211 C9.57706196,46.3684211 11.3333333,44.5979289 11.3333333,42.4078947 C11.3333333,40.2178606 9.57706196,38.4473684 7.41666667,38.4473684 C5.25627138,38.4473684 3.5,40.2178606 3.5,42.4078947 C3.5,44.5979289 5.25627138,46.3684211 7.41666667,46.3684211 Z" id="Oval"></path>
                                      <path d="M42.0833333,14.4210526 C38.2606438,14.4210526 35.1666667,11.302023 35.1666667,7.46052632 C35.1666667,3.61902961 38.2606438,0.5 42.0833333,0.5 C45.9060228,0.5 49,3.61902961 49,7.46052632 C49,11.302023 45.9060228,14.4210526 42.0833333,14.4210526 Z M42.0833333,11.4210526 C44.2437286,11.4210526 46,9.65056043 46,7.46052632 C46,5.2704922 44.2437286,3.5 42.0833333,3.5 C39.922938,3.5 38.1666667,5.2704922 38.1666667,7.46052632 C38.1666667,9.65056043 39.922938,11.4210526 42.0833333,11.4210526 Z" id="Oval"></path>
                                  </g>
                                  <g id="Group-15" transform="translate(15.000000, 15.000000)" fill="#D8D8D8" stroke="#F6A31E" stroke-width="2.43">
                                      <rect id="Rectangle" x="2.215" y="2.215" width="1" height="1"></rect>
                                      <rect id="Rectangle" x="17.215" y="2.215" width="1" height="1"></rect>
                                      <rect id="Rectangle" x="12.215" y="2.215" width="1" height="1"></rect>
                                      <rect id="Rectangle" x="7.215" y="2.215" width="1" height="1"></rect>
                                      <rect id="Rectangle" x="2.215" y="7.215" width="1" height="1"></rect>
                                      <rect id="Rectangle" x="2.215" y="12.215" width="1" height="1"></rect>
                                      <rect id="Rectangle" x="2.215" y="17.215" width="1" height="1"></rect>
                                      <rect id="Rectangle" x="7.215" y="17.215" width="1" height="1"></rect>
                                      <rect id="Rectangle" x="12.215" y="17.215" width="1" height="1"></rect>
                                      <rect id="Rectangle" x="17.215" y="17.215" width="1" height="1"></rect>
                                      <rect id="Rectangle" x="17.215" y="12.215" width="1" height="1"></rect>
                                      <rect id="Rectangle" x="17.215" y="7.215" width="1" height="1"></rect>
                                  </g>
                                  <path d="M18.4547299,16.6470588 L16.4375,16.6470588 L16.4375,18.8733471 L9.35827756,11.736803 L11.4881343,9.62405352 L18.4547299,16.6470588 Z M33.5,31.8141529 L39.6838031,38.0480273 L37.5539464,40.1607768 L31.180074,33.7352941 L33.5,33.7352941 L33.5,31.8141529 Z" id="Combined-Shape" fill="#F6A31E" fill-rule="nonzero"></path>
                              </g>
                          </g>
                      </g>
                  </g>
              </g>
          </svg>
        </span>
        <span id="text-span">
          <h1>Velkommen til RetVejkode</h1>
          <p>Klik start for at arbejde, eller vælg en opgave herunder</p>
        </span>
        <span id="button-span">
          <StartButton :onClick="startButtonClick" />
        </span>

      </div>
      </div>
    <OpgaveListe :opgaver="this.$store.state.opgaver.nye" :title="'Opgaver'" />
    <OpgaveListe :opgaver="this.$store.state.opgaver.sendt" :title="'Sendt til GeoDK'" />
    <OpgaveListe :opgaver="this.$store.state.opgaver.afsluttet" :title="'Afsluttet hos GeoDK'" />
  </div>
</template>

<script>
// @ is an alias to /src
import { signin } from '@/auth';
import OpgaveListe from '@/components/home/OpgaveListe.vue';
import StartButton from '@/components/home/StartButton.vue';
import Button from '@/components/common/Button.vue';
import IconRetVejkodeActive from '@/components/common/Icon/IconRetVejkode/IconRetVejkodeActive.vue';
import IconSeptima from '@/components/common/Icon/IconSeptima/IconSeptima.vue';
export default {
  name: 'home',
  components: {
    OpgaveListe,
    IconRetVejkodeActive,
    IconSeptima,
    Button,
    StartButton,
  },
  data: function () {
    return {
      loading: false,
    };
  },
  computed: {
    user () {
      return this.$store.state.user;
    },
    isLoading () {
      return this.$store.state.loading;
    },
  },
  methods: {
    onLogin () {
      this.$store.commit('setLoading', true);
      signin();
    },
    startButtonClick () {
      this.$router.push('map');
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  margin: 30px 0 0 0;
  font-size: 22px;
}
h2 {
  font-size: 15px;
  color: $text-secondary-color;
}
button {
  margin-top: 40px;
}
.login{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.home{
  flex: 1;
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  overflow-x: hidden;
  // align-items: center;
  /* justify-content: center; */
}

.jumbotron-wrapper {
  width: 100%;
  padding: 90px 110px 20px 110px;
}
.jumbotron {
  background-image: linear-gradient(154deg, #8527D8 16%, #B000E1 100%);
  box-shadow: -7px 16px 43px 0 #D4DBEC;
  border-radius: 6px;

  width: 300px;
  height: 280px;

  display: flex;
  align-items: center;

  color: #FFFFFF;
  h1 {
    color: #FFFFFF;
    font-size: 30px;
  }
  p {
    font-size: 20px;
  }
}

@media (min-width: 920px) {
  .jumbotron {
    width: 620px;
 }
}
@media (min-width: 1240px) {
  .jumbotron {
    width: 940px;
 }
}
@media (min-width: 1560px) {
  .jumbotron {
    width: 1260px;
 }
}
@media (min-width: 1880px) {
  .jumbotron {
    width: 1580px;
 }
}

#icon-span {
  width:250px;
  padding-left:70px;
}
#text-span {

}
#button-span {
  margin-left: auto;
  margin-right: 140px;
}

@media (max-width: 1240px) {
  #icon-span {
    padding: 20px 0;
  }
  #button-span {
    margin: 0;
  }
  .jumbotron {
    padding: 0 10px;
    height: 460px;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
}

@media (max-width: 600px) {
  .jumbotron-wrapper {
    padding: 10px 10px 20px 10px;
  }
}

.icon-septima {
  z-index: -1;
  position: absolute;
  right: 20px;
  top: 20px;
}
</style>
